import {
  Report as AccidentsIcon,
  Check as ChecklistIcon,
  Person as CustomersIcon,
  Dashboard as DashboardIcon,
  Assignment as LicenseTrackerIcon,
  Build as MaintenanceIcon,
  ShoppingCart as OrdersIcon,
  People as UsersIcon, // Updated icon for Checklist
  DirectionsCar as VehicleServiceIcon,
  DirectionsCarFilled as VehiclesIcon
} from "@mui/icons-material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const FloatingActionButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const styles = {
    container: {
      position: "fixed",
      bottom: "2rem",
      right: "2rem",
      zIndex: 1000,
    },
    menuContainer: {
      display: "flex",
      flexDirection: "column-reverse",
      gap: "1rem",
      marginBottom: "1rem",
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      gap: "0.5rem",
      padding: "0.5rem 1rem",
      backgroundColor: "#2563eb",
      color: "white",
      border: "none",
      borderRadius: "0.5rem",
      cursor: "pointer",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "all 0.2s ease",
    },
    menuItemHover: {
      backgroundColor: "#1d4ed8",
      transform: "scale(1.05)",
    },
    mainButton: {
      width: "3.5rem",
      height: "3.5rem",
      backgroundColor: "#2563eb",
      color: "white",
      border: "none",
      borderRadius: "50%",
      cursor: "pointer",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isOpen ? "rotate(45deg)" : "rotate(0)",
    },
    icon: {
      width: "1.5rem",
      height: "1.5rem",
    },
  };

  const menuItems = [
    {
      label: "Dashboard",
      path: "/admin/dashboard",
      icon: <DashboardIcon style={styles.icon} />,
    },
    {
      label: "Maintenance",
      path: "/admin/maintenance",
      icon: <MaintenanceIcon style={styles.icon} />,
    },
    {
      label: "Checklist",
      path: "/admin/checklist",
      icon: <ChecklistIcon style={styles.icon} />, // Updated icon
    },
    {
      label: "Vehicle Service",
      path: "/admin/vehicle-service",
      icon: <VehicleServiceIcon style={styles.icon} />,
    },
    {
      label: "Accidents",
      path: "/admin/accident",
      icon: <AccidentsIcon style={styles.icon} />,
    },
    {
      label: "Orders",
      path: "/admin/orders",
      icon: <OrdersIcon style={styles.icon} />,
    },

    {
      label: "Users",
      path: "/admin/users",
      icon: <UsersIcon style={styles.icon} />,
    },
    {
      label: "Vehicles",
      path: "/admin/vehicle",
      icon: <VehiclesIcon style={styles.icon} />,
    },
    {
      label: "Customers",
      path: "/admin/customers",
      icon: <CustomersIcon style={styles.icon} />,
    },
    {
      label: "License Tracker",
      path: "/admin/license",
      icon: <LicenseTrackerIcon style={styles.icon} />,
    },
  ];

  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div style={styles.container}>
      {isOpen && (
        <div style={styles.menuContainer}>
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                if (item.path) {
                  navigate(item.path);
                  setIsOpen(false); // Close the menu after navigating
                }
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                ...styles.menuItem,
                ...(hoveredIndex === index ? styles.menuItemHover : {}),
              }}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={styles.mainButton}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#1d4ed8";
          e.currentTarget.style.transform = `${
            isOpen ? "rotate(45deg)" : "rotate(0)"
          } scale(1.05)`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#2563eb";
          e.currentTarget.style.transform = isOpen
            ? "rotate(45deg)"
            : "rotate(0)";
        }}
      >
        <DashboardIcon style={styles.icon} />
      </button>
    </div>
  );
};

export default FloatingActionButton;
